(function () {
  'use strict';

  if (window.matchMedia('(min-width: 1024px)').matches) return;

  var section    = document.querySelector('[data-qt-story-section]');
  var stage      = section && section.querySelector('.qt-story-stage');
  var slides     = section ? Array.from(section.querySelectorAll('[data-qt-story-slide]')) : [];
  var pagination = section && section.querySelector('[data-qt-story-pagination]');

  if (!section || !stage || slides.length === 0) return;

  var totalSlides  = slides.length;
  var currentIndex = -1;

  function setHeight() {
    section.style.height = (totalSlides * 100) + 'vh';
  }
  setHeight();

  /* 2. Setup pagination dots */
  pagination.innerHTML = '';
  pagination.classList.remove('hidden');
  pagination.classList.add('flex');

  var dots = slides.map(function (_, i) {
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'qt-story-dot';
    btn.setAttribute('aria-label', 'Go to slide ' + (i + 1));
    btn.addEventListener('click', function () { scrollToSlide(i); });
    pagination.appendChild(btn);
    return btn;
  });

  var flashEl = document.createElement('div');
  flashEl.className = 'qt-story-flash';
  stage.appendChild(flashEl);

  function triggerFlash() {
    flashEl.classList.remove('is-flashing');
    void flashEl.offsetWidth;
    flashEl.classList.add('is-flashing');
    flashEl.addEventListener('animationend', function () {
      flashEl.classList.remove('is-flashing');
    }, { once: true });
  }

  function showSlide(index) {
    if (index === currentIndex) return;
    currentIndex = index;

    slides.forEach(function (s, i) {
      if (i === index) {
        s.classList.add('is-active');
      } else {
        s.classList.remove('is-active');
      }
    });

    dots.forEach(function (d, i) {
      d.classList.toggle('is-active', i === index);
    });
  }

  /* 3. Handle scroll progress */
  function onScroll() {
    var rect = section.getBoundingClientRect();
    var scrolledIn  = -rect.top; 
    var scrollRange = section.offsetHeight - window.innerHeight;

    if (scrolledIn <= 0) {
      showSlide(0);
      return;
    }

    if (scrolledIn >= scrollRange) {
      showSlide(totalSlides - 1);
      return;
    }

    var progress = scrolledIn / scrollRange;
    var index = Math.min(totalSlides - 1, Math.floor(progress * totalSlides));
    showSlide(index);
  }

  window.addEventListener('scroll', onScroll, { passive: true });

  /* 4. Scroll-to specific slide */
  function scrollToSlide(index) {
    var sectionTop  = section.getBoundingClientRect().top + window.scrollY;
    var scrollRange = section.offsetHeight - window.innerHeight;

    if (index >= totalSlides) {
      window.scrollTo({ top: sectionTop + section.offsetHeight, behavior: 'smooth' });
      return;
    }

    if (index < 0) {
      window.scrollTo({ top: Math.max(0, sectionTop - window.innerHeight), behavior: 'smooth' });
      return;
    }

    var fraction = totalSlides > 1 ? index / totalSlides : 0;
    var targetY  = sectionTop + fraction * scrollRange + 2;
    window.scrollTo({ top: targetY, behavior: 'smooth' });
  }

  section.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-qt-story-scroll-down]');
    if (btn) scrollToSlide(currentIndex + 1);
  });

  /* 5. Touch swipe handling */
  var touchY = null;
  stage.addEventListener('touchstart', function (e) {
    touchY = e.touches[0].clientY;
  }, { passive: true });

  stage.addEventListener('touchend', function (e) {
    if (touchY === null) return;
    var delta = touchY - e.changedTouches[0].clientY;
    touchY = null;

    if (Math.abs(delta) < 40) return;

    var rect = section.getBoundingClientRect();
    if (rect.top > 30) return;

    var goingForward = delta > 0;
    var target = goingForward ? currentIndex + 1 : currentIndex - 1;

    if (goingForward && currentIndex === totalSlides - 1) {
      triggerFlash();
      scrollToSlide(totalSlides);
      return;
    }

    if (!goingForward && currentIndex === 0) {
      triggerFlash();
      scrollToSlide(-1);
      return;
    }

    triggerFlash();
    scrollToSlide(target);
  }, { passive: true });

  /* 6. Resize handler */
  window.addEventListener('resize', function () {
    if (window.matchMedia('(min-width: 1024px)').matches) {
      section.style.height = ''; 
      return;
    }
    setHeight();
    onScroll();
  }, { passive: true });

  showSlide(0);
  onScroll();
})();
